import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <section className="notfound">
      <Seo
        title="Page not found"
        description="This page doesn't exist. Return to the OLYMPUS MEDS catalog."
        noindex
      />
      <div className="notfound__inner">
        <div className="notfound__code">404</div>
        <h1 className="notfound__title">Page not found.</h1>
        <p className="notfound__sub">The page you're looking for doesn't exist in the catalog.</p>
        <Link to="/" className="btn btn--primary">
          Return home →
        </Link>
      </div>
    </section>
  );
}
